import { render, staticRenderFns } from "./NewPaymentsType.vue?vue&type=template&id=2482e2e2&scoped=true"
import script from "./NewPaymentsType.vue?vue&type=script&lang=js"
export * from "./NewPaymentsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2482e2e2",
  null
  
)

export default component.exports